import React, { useState, useEffect, forwardRef, useImperativeHandle, Suspense } from 'react';
import './InvoiceFilterationAction.css';
import Swal from 'sweetalert2';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import {
    ArrowLeft, Edit3, Banknote, GripVertical, Trash2, ChevronUp, ChevronDown, ChevronRight, X, Search, Settings
} from 'lucide-react';
import Loader from '../../../components/Loader/Loader';
import AddProductForm from '../../../components/LeadForm/AddProductForm';
import 'react-quill-new/dist/quill.snow.css';

import ReactQuill from 'react-quill-new';

// Safe wrapper for ReactQuill to avoid concurrent rendering issues
const SafeQuill = React.memo(forwardRef((props, ref) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    if (!mounted) return <div className="quill-editor-wrap" style={{ minHeight: 120 }} />;
    return <ReactQuill ref={ref} {...props} />;
}));

const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['blockquote'],
        [{ 'align': [] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'color': [] }, { 'background': [] }],
        ['image', 'link'],
        ['clean']
    ]
};

let globalNextInvoiceNumber = parseInt(localStorage.getItem('lastInvoiceNumber')) || 3067;

const InvoiceFilterationAction = forwardRef(({
    editView, setEditView,
    editForm, setEditForm,
    fetchInvoices,
    getToken
}, ref) => {
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || 'https://wcfkit19.azurewebsites.net').replace(/\/$/, '');
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const GET_INVOICE_DETAILS_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_INVOICE_DETAILS}`.trim();
    const OWNER_DROPDOWN =`${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_OWNER_DROPDOWN}`.trim();
    const LEAD_tax = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_TAX_LIST_BYMODE_ENTITYID}`.trim();
    const Get_country = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_COUNTRY}`.trim();
    const Get_State = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_STATE_BY_COUNTRY}`.trim();
    const GET_CITY_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_CITY_BY_STATE}`.trim();
    const Get_preview_list_edit = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_PREVIEW_LIST_EDIT}`.trim();

    const ADD_TAX_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.ADD_TAX_SUGGESTION}`.trim();
    const ADD_ITEM_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.ADD_ITEM_SUGGESTION}`.trim();
    const GET_DIFF_CUSTOMER_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_DIFF_CUSTOMER_SUGGESTION}`.trim();
    const Get_currency = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_CURRENCY_LIST}`.trim();
    const INSERT_NEW_INVOICE_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.INSERT_NEW_INVOICE}`.trim();
    const Cancel_Invoice = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.CANCEL_INVOICE}`.trim();
    const IS_INVOICE_ALREADY_GENERATED = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.IS_INVOICE_ALREADY_GENERATED}`.trim();
    const Get_Invoice_Link = `${NEW_BASE_URL}${API_ENDPOINTS.INVOICE.PRINT_INVOICE}`;
    const Get_Segmentation_list = `${NEWV3_BASE_URL}/${API_ENDPOINTS.SEGMENTATION.GET_SEGMENTATION_LIST.replace(/^\/+/, '')}`.trim();
    const Mark_As_Sent = `${API_BASE}${API_ENDPOINTS.INVOICE.MARK_AS_SENT_INVOICE}`.trim();
  const GET_DOWNLOAD_TEMPLATE = `${NEW_BASE_URL}${API_ENDPOINTS.Quotation.GET_DOWNLOAD_TEMPLATE}`;
   const Download_Invoice_Template = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.DOWNLOAD_INVOICE_TEMPLATE}`.trim();

     const Choose_Placeholder = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.CHOOSE_PLACEHOLDER_FOR_PREVIEW.replace(/^\/+/, '')}`.trim();
    const GET_COMPANY_SETTING_DATA = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_COMPANY_SETTING_DATA}`.trim();
    const GET_SETTING_BY_SECTION = `${API_BASE}/UserCRMCampaign/Service/InvoiceService.asmx/GetSettingBySection`;
    const safeStr = (v) => (v === null || v === undefined) ? '' : String(v).trim();

    const getFinancialYear = (format) => {
        const now = new Date();
        const nextYear = new Date(now);
        nextYear.setFullYear(now.getFullYear() + 1);

        const yy = now.getFullYear().toString().slice(-2);
        const yyyy = now.getFullYear();
        const nextYY = nextYear.getFullYear().toString().slice(-2);
        const nextYYYY = nextYear.getFullYear();

        switch (format) {
            case "YY-YY": return `${yy}-${nextYY}`;
            case "YYYY-YYYY": return `${yyyy}-${nextYYYY}`;
            case "YYYY-YY": return `${yyyy}-${nextYY}`;
            case "YYYY/YY": return `${yyyy}/${nextYY}`;
            case "YY/YY": return `${yy}/${nextYY}`;
            case "YYYY/YYYY": return `${yyyy}/${nextYYYY}`;
            default: return `${yy}-${nextYY}`;
        }
    };

    const padNumber = (num, digits) => {
        return num.toString().padStart(digits, "0");
    };

    const generateInvoiceNumber = ({ prefix, nextNumber, numberDigits, financialYearFormat }) => {
        const finYear = getFinancialYear(financialYearFormat);
        const paddedNumber = padNumber(nextNumber, numberDigits);
        return `${prefix}/${finYear}/${paddedNumber}`;
    };

    const generateAddInvoiceNumber = () => {
        const companySettings = {
            prefix: "INV-654",
            nextNumber: globalNextInvoiceNumber,
            numberDigits: 4,
            financialYearFormat: "YY-YY"
        };
        return generateInvoiceNumber(companySettings);
    };

    const generateDuplicateNumber = (originalNum) => {
        if (!originalNum) return generateAddInvoiceNumber();
        const parts = originalNum.split('/');
        if (parts.length > 0) {
            const lastPart = parts[parts.length - 1];
            if (!isNaN(lastPart) && lastPart.trim() !== '') {
                const nextNum = parseInt(lastPart, 10) + 1;
                parts[parts.length - 1] = padNumber(nextNum, lastPart.length);
                return parts.join('/');
            }
        }
        return `${originalNum}-COPY`;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${String(d.getDate()).padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()}`;
    };

    // ─── Edit View State ─────────────────────────────────────────────────────
    const [editLoading, setEditLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [companyOpen, setCompanyOpen] = useState(false);
    const [ownerOptions, setOwnerOptions] = useState([]);
    const [isDuplicateMode, setIsDuplicateMode] = useState(false);

    // Memoized handlers for Quill to avoid re-renders during save/loading
    const handleTermsChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, termsCondition: val }));
    }, [setEditForm]);

    const handleNotesChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, notes: val }));
    }, [setEditForm]);

    const handleFooterChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, footer: val }));
    }, [setEditForm]);

    // ─── Bill To Modal State ──────────────────────────────────────────────────
    const [billToOpen, setBillToOpen] = useState(false);
    const [billToForm, setBillToForm] = useState({});
    const [leadTaxOptions, setLeadTaxOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [isSameAsBillTo, setIsSameAsBillTo] = useState(false);
    const [shipToOpen, setShipToOpen] = useState(false);
    const [shipToForm, setShipToForm] = useState({
        name: '', email: '', phone: '', address: '', countryId: '', countryName: '', stateId: '', stateName: '', cityId: '', cityName: '', pincode: ''
    });
    const [isProductAddOpen, setIsProductAddOpen] = useState(false);

    // Item Edit Modals state
    const [itemEntityModal, setItemEntityModal] = useState({ open: false, index: -1, value: '', type: 'existing' });
    const [itemDescModal, setItemDescModal] = useState({ open: false, index: -1, value: '', type: 'existing' });
    const [previewOptions, setPreviewOptions] = useState([]);
    const [placeholderOptions, setPlaceholderOptions] = useState([]);
    const [placeholderModalOpen, setPlaceholderModalOpen] = useState(false);

    const quillRef = React.useRef(null);

    // Per-item discount: { [itemKey]: { active, type, value } }
    const [itemDiscounts, setItemDiscounts] = useState({});

    // Per-item added taxes: { [itemKey]: [{ Id, Name, Rate, Type }] }
    const [itemAddedTaxes, setItemAddedTaxes] = useState({});

    // Per-item tax search: { [itemKey]: boolean }
    const [itemTaxSearchOpen, setItemTaxSearchOpen] = useState({});
    const [taxSearchText, setTaxSearchText] = useState('');
    const [taxSuggestions, setTaxSuggestions] = useState([]);

    // Add Item state
    const [addedItems, setAddedItems] = useState([]);
    const [itemSearchOpen, setItemSearchOpen] = useState(false);
    const [itemSearchText, setItemSearchText] = useState('');
    const [itemSuggestions, setItemSuggestions] = useState([]);

    // Add Charges state
    const [addedCharges, setAddedCharges] = useState([]); // [{ type, amount }]
    const [chargeModal, setChargeModal] = useState({ open: false, type: '', amount: '' });
    const [footerOpen, setFooterOpen] = useState(false);
    const [currencyList, setCurrencyList] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    useEffect(() => {
        if (editView && currencyList.length > 0) {
            if (editView._isAdd) {
                const inr = currencyList.find(c => c.Code === 'INR');
                if (inr) setSelectedCurrency(inr);
            } else {
                const currentCurrencyId = String(editView.CurrencyId || editView._invoice?.CurrencyId || '');
                if (currentCurrencyId) {
                    const matched = currencyList.find(c => String(c.Id) === currentCurrencyId);
                    if (matched) setSelectedCurrency(matched);
                }
            }
        }
    }, [editView, currencyList]);

    // Customer search state
    const [customerSearchOpen, setCustomerSearchOpen] = useState(false);
    const [customerSearchText, setCustomerSearchText] = useState('');
    const [customerSuggestions, setCustomerSuggestions] = useState([]);

    const fetchPlaceholders = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(Choose_Placeholder, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } })
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Details || data?.Details || data?.d || data?.Data || data?.data || data || [];
                setPlaceholderOptions(Array.isArray(list) ? list : (list.placeholders || []));
            }
        } catch (err) {
            console.error('Error fetching placeholders:', err);
        }
    };

    const handleInsertPlaceholder = (tag) => {
        if (!quillRef.current) return;
        const editor = quillRef.current.getEditor();
        const selection = editor.getSelection();
        const cursorPosition = selection ? selection.index : editor.getLength();
        editor.insertText(cursorPosition, `#${tag}#\n`);
        setPlaceholderModalOpen(false);
    };

    // ─── Customer Suggestion API ─────────────────────────────────────────────
    const fetchCustomerSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setCustomerSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(GET_DIFF_CUSTOMER_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10), FilterText: filterText } })
            });
            if (response.ok) {
                const data = await response.json();
                setCustomerSuggestions(data?.Details || data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Customer suggestion error:', err);
        }
    };

    const cleanPin = (v) => {
        let s = String(v || "").trim();
        if (s === "0" || s === "000000") return "";
        // Fix: Remove extra appending "121213" as reported by user
        if (s.endsWith("121213") && s.length > 6) {
            s = s.slice(0, -6);
        }
        return s;
    };

    const handleSelectCustomer = async (customer) => {
        const isNumeric = (val) => /^\d+$/.test(String(val || ''));

        // Helper to resolve name from API if ID is numeric
        const resolveStateName = async (cId, sId, currentName) => {
            if (!cId || !sId) return currentName;
            if (!isNumeric(sId) && !isNumeric(currentName) && currentName) return currentName;
            try {
                const API_BASE_WCF = (process.env.REACT_APP_WCF_API_BASE_URL || 'https://wcfkit19.azurewebsites.net').replace(/\/$/, '');
                const Get_State = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_STATE_BY_COUNTRY}`.trim();
                const res = await fetch(Get_State, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(String(cId), 10) } })
                });
                if (res.ok) {
                    const data = await res.json();
                    const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                    const match = list.find(o => String(o.Id || o.Value || o.Code) === String(sId));
                    if (match) return match.Text || match.Value || match.Name || '';
                }
            } catch (e) { console.error('resolveStateName error:', e); }
            return currentName;
        };

        const resolveCityName = async (sId, ctId, currentName) => {
            if (!sId || !ctId) return currentName;
            if (!isNumeric(ctId) && !isNumeric(currentName) && currentName) return currentName;
            try {
              
                // const GET_CITY_URL = `${API_BASE_WCF}${API_ENDPOINTS.INVOICE.GET_CITY_BY_STATE}`.trim();
                const res = await fetch(GET_CITY_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(String(sId), 10) } })
                });
                if (res.ok) {
                    const data = await res.json();
                    const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                    const match = list.find(o => String(o.Id || o.Value || o.Code) === String(ctId));
                    if (match) return match.Text || match.Value || match.Name || '';
                }
            } catch (e) { console.error('resolveCityName error:', e); }
            return currentName;
        };

        const leadId = customer.LeadId || customer.Id || 0;
        const name = customer.PersonName || customer.Name || '';
        const email = customer.EmailID || customer.Email || customer.EmailId || '';
        const phone = customer.MobileNo || customer.Mobile || customer.Phone || '';
        const address = customer.Address || '';
        const company = customer.CompanyName || '';
        const taxNumber = customer.TaxNumber || '';
        const panNumber = customer.PanNumber || '';
        const countryId = customer.CountryId || customer.countryid || customer.CountryID || (isNumeric(customer.Country) ? String(customer.Country) : '');
        let countryName = customer.Country || customer.CountryName || '';
        if (!countryName && countryId) {
            const match = (countryOptions || []).find(o => String(o.Id || o.Value) === String(countryId));
            if (match) countryName = match.Text || match.Name || '';
        }

        const stateId = customer.StateId || customer.stateid || customer.StateID || (isNumeric(customer.State) ? String(customer.State) : '') || '';
        let stateName = customer.State || customer.state || customer.StateName || '';
        stateName = await resolveStateName(countryId, stateId || stateName, stateName);

        const cityId = customer.CityId || customer.cityid || customer.CityID || (isNumeric(customer.City) ? String(customer.City) : '') || '';
        let cityName = customer.City || customer.city || customer.CityName || '';
        cityName = await resolveCityName(stateId || stateName, cityId || cityName, cityName);

        const pincode = cleanPin(customer.PinCode) || cleanPin(customer.pincode) || "";

        const companyState = editView?.CompanyState || editView?.CompanyStateName || "";
        let resolvedCompanyState = companyState === 'Berat' || companyState === '1' ? 'India' : companyState;
        if (isNumeric(companyState) && (editView?.CompanyCountryId || editView?.CompanyCountryID)) {
             resolvedCompanyState = await resolveStateName(editView.CompanyCountryId || editView.CompanyCountryID, companyState, companyState);
             if (resolvedCompanyState === 'Berat') resolvedCompanyState = 'India';
        }

        const updateData = {
            name, email, phone, address, company,
            cityName, stateName, countryName, pincode,
            taxNumber, panNumber,
            cityId, stateId, countryId,
        };

        setBillToForm(prev => ({ ...prev, ...updateData }));
        setShipToForm(prev => ({ ...prev, ...updateData }));

        // Also update the editView with the new customer info for persistence/rendering fallback
        setEditView(prev => ({
            ...prev,
            LeadId: parseInt(leadId),
            ContactName: name,
            ContactEmail: email,
            ContactPhone: phone,
            ContactAddress: address,
            BillToCompanyName: company,
            BillToCity: cityName,
            BillToState: stateName,
            BillToCountry: countryName,
            BillToPincode: pincode,
            ContactTaxNumber: taxNumber,
            ContactPanNumber: panNumber,
            BillToTaxNumber: taxNumber,
            BillToPanNumber: panNumber,
            BillToCityId: cityId,
            BillToStateId: stateId,
            BillToCountryId: countryId,
            // Mirror to ShipTo fields for full parity upon selection
            ShipToName: name,
            ShipToEmailId: email,
            ShipToPhone: phone,
            ShipToAddress: address,
            ShipToCity: cityName,
            ShipToState: stateName,
            ShipToCountry: countryName,
            ShipToPincode: pincode,
            ShipToCityId: cityId,
            ShipToStateId: stateId,
            ShipToCountryId: countryId,
            ShipToCompanyName: company,
            ShipToTaxNumber: taxNumber,
            ShipToPanNumber: panNumber,
            leadDetail: {
                ...(prev?.leadDetail || {}),
                PersonName: name,
                MobileNo: phone,
                EmailID: email,
                Address: address,
                CompanyName: company,
                Country: countryName,
                CountryId: countryId,
                State: stateName,
                StateId: stateId,
                City: cityName,
                CityId: cityId,
                PinCode: pincode,
                TaxNumber: taxNumber,
                PanNumber: panNumber,
            }
        }));

        // Trigger fetches for address dropdowns and tax options
        if (countryId) fetchStates(countryId);
        if (stateId) fetchCities(stateId);
        if (leadId) fetchLeadTax(leadId, true);

        // --- Fetch Full Lead Details for Robust ID Binding ---
        try {
            const NEWV3_BASE_URL_INTERNAL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
            const GetLead_Details = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.COMMON.GET_LEAD_BY_ID}`.trim();
            const token = getToken() || "-2295521862261168";
            
            const uid = localStorage.getItem('userId') || '34594';
            const detailsStr = JSON.stringify({
                draw: 1,
                StartNo: 0,
                EndNo: 1,
                UserId: parseInt(uid, 10),
                ParentId: parseInt(uid, 10),
                FilterText: `ID=${leadId}`
            });

            const response = await fetch(GetLead_Details, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: detailsStr
                })
            });

            if (response.ok) {
                const fullRes = await response.json();
                let parsedDetails = fullRes?.Details;
                if (typeof parsedDetails === 'string') {
                    try { parsedDetails = JSON.parse(parsedDetails); } catch(e) {}
                }
                const fullLead = parsedDetails?.data?.[0] || parsedDetails || fullRes?.d || fullRes?.data || {};

                if (fullLead && Object.keys(fullLead).length > 0) {
                    const cId = fullLead.CountryId || fullLead.countryid || fullLead.CountryID || (isNumeric(fullLead.Country) ? String(fullLead.Country) : '');
                    const sId = fullLead.StateId || fullLead.stateid || fullLead.StateID || (isNumeric(fullLead.State) ? String(fullLead.State) : '');
                    const ctId = fullLead.CityId || fullLead.cityid || fullLead.CityID || (isNumeric(fullLead.City) ? String(fullLead.City) : '');
                    const cNm = fullLead.CountryName || fullLead.Country || '';
                    let sNm = fullLead.StateName || fullLead.State || '';
                    sNm = await resolveStateName(cId || countryId, sId || sNm, sNm);

                    let ctNm = fullLead.CityName || fullLead.City || '';
                    ctNm = await resolveCityName(sId || sNm, ctId || ctNm, ctNm);
                    const fTax = (fullLead.TaxNumber || '').trim();
                    const fPan = (fullLead.PanNumber || '').trim();

                    const fullData = {
                        countryId: cId || countryId,
                        countryName: cNm || countryName,
                        stateId: sId || stateId,
                        stateName: sNm || stateName,
                        cityId: ctId || cityId,
                        cityName: ctNm || cityName,
                        pincode: cleanPin(fullLead.PinCode) || cleanPin(fullLead.pincode) || pincode,
                        taxNumber: fTax || taxNumber,
                        panNumber: fPan || panNumber,
                        address: fullLead.Address || address
                    };

                    setBillToForm(prev => ({ ...prev, ...fullData }));
                    setShipToForm(prev => ({ ...prev, ...fullData }));

                    setEditView(prev => ({
                        ...prev,
                        BillToTaxNumber: fTax || taxNumber,
                        BillToPanNumber: fPan || panNumber,
                        ShipToTaxNumber: fTax || taxNumber,
                        ShipToPanNumber: fPan || panNumber,
                        leadDetail: {
                            ...(prev?.leadDetail || {}),
                            ...fullLead,
                            CountryId: cId,
                            StateId: sId,
                            CityId: ctId,
                            Country: cNm,
                            State: sNm,
                            City: ctNm
                        }
                    }));

                    if (cId) fetchStates(cId);
                    if (sId) fetchCities(sId);
                }
            }
        } catch (err) {
            console.error('Error fetching full lead details in Invoice:', err);
        }

        // Automate Place of Supply and Place of Origin based on customer state
        setEditForm(prev => ({
            ...prev,
            placeOfOrigin: resolvedCompanyState || stateName || '',
            placeOfSupply: stateName || resolvedCompanyState || '',
        }));

        setCustomerSearchOpen(false);
        setCustomerSearchText('');
        setCustomerSuggestions([]);
    };

    // ─── Tax Suggestion API ─────────────────────────────────────────────────
    const fetchTaxSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setTaxSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(ADD_TAX_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    Token: "-2295521862261168", 
                    Details: { 
                        FilterText: filterText, 
                        UserId: parseInt(userId, 10) 
                    } 
                })
            });
            if (response.ok) {
                const data = await response.json();
                setTaxSuggestions(data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Tax suggestion error:', err);
        }
    };

    const handleSelectTax = (tax, itemKey) => {
        const newTax = { Id: tax.Id, Name: tax.Name, Rate: parseFloat(tax.Rate) || 0, Type: tax.Type || 'percentage' };
        setItemAddedTaxes(prev => ({ ...prev, [itemKey]: [...(prev[itemKey] || []), newTax] }));
        setItemTaxSearchOpen(prev => ({ ...prev, [itemKey]: false }));
        setTaxSearchText('');
        setTaxSuggestions([]);
    };

    const handleDeleteAddedTax = (itemKey, taxIndex) => {
        setItemAddedTaxes(prev => ({ ...prev, [itemKey]: (prev[itemKey] || []).filter((_, i) => i !== taxIndex) }));
    };

    // ─── Item Suggestion API ────────────────────────────────────────────────
    const fetchItemSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setItemSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(ADD_ITEM_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    Token: "-2295521862261168", 
                    Details: { 
                        FilterText: filterText, 
                        SectionName: "invoice", 
                        UserId: parseInt(userId, 10) 
                    } 
                })
            });
            if (response.ok) {
                const data = await response.json();
                setItemSuggestions(data?.Details || data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Item suggestion error:', err);
        }
    };

    const handleSelectItem = (product) => {
        const price = parseFloat(product.SalePrice || product.Price || product.Rate || product.SalesPrice || 0);
        // Parse HSNCode from ProductJSON if available
        let hsnCode = product.HSNCode || product.SACCode || '';
        try { const pj = JSON.parse(product.ProductJSON || '{}'); hsnCode = pj.HSNCode || pj.SACCode || hsnCode; } catch (e) { }
        // Map HomeTaxes to invoiceItemTaxes format
        const taxes = (product.HomeTaxes || []).map(t => ({
            Id: t.Id, Name: t.TaxName, Rate: t.TaxRate, Amount: (price * t.TaxRate) / 100, Type: t.TaxType || 'percentage'
        }));
        const taxNames = taxes.map(t => `${t.Name}: ${t.Rate}%`).join(', ');
        const taxAmount = taxes.reduce((s, t) => s + (t.Amount || 0), 0);
        const newItem = {
            Name: product.Name || product.ProductName || '-',
            Description: product.Description || '',
            Quantity: 1,
            Price: price,
            Total: price,
            ItemHsnSacCode: hsnCode,
            ItemTax: taxNames || '-',
            ItemTaxAmount: taxAmount > 0 ? `${taxNames}: ${taxAmount.toFixed(2)}` : '-',
            invoiceItemTaxes: taxes,
        };
        setAddedItems(prev => [...prev, newItem]);
        setItemSearchOpen(false);
        setItemSearchText('');
        setItemSuggestions([]);
    };

    const handleDeleteAddedItem = (index) => {
        const key = `added-${index}`;
        setAddedItems(prev => prev.filter((_, i) => i !== index));
        setItemDiscounts(prev => { const n = { ...prev }; delete n[key]; return n; });
        setItemAddedTaxes(prev => { const n = { ...prev }; delete n[key]; return n; });
    };

    // Per-item discount helpers
    const getDiscount = (key) => itemDiscounts[key] || { active: false, type: 'percentage', value: 0 };
    const setDiscountForItem = (key, updater) => {
        setItemDiscounts(prev => ({
            ...prev,
            [key]: typeof updater === 'function' ? updater(prev[key] || { active: false, type: 'percentage', value: 0 }) : updater
        }));
    };

    // ─── API Functions ────────────────────────────────────────────────────────
    const fetchOwners = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(OWNER_DROPDOWN, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } })
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Status === 1 && data?.Details ? data.Details : (data?.Details || data?.d || data?.Data || data?.data || data || []);
                setOwnerOptions(Array.isArray(list) ? list : []);
            }
        } catch (err) {
            console.error('Error fetching owners:', err);
        }
    };

    const fetchCurrencyList = async () => {
        try {
            const response = await fetch(Get_currency, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: "" })
            });
            if (response.ok) {
                const data = await response.json();
                let list = data?.Details || data?.Details || data?.d || data?.Data || data?.data || [];
                if (Array.isArray(list)) {
                    list = list.map(c => {
                        if (c.Code === 'INR') {
                            return { ...c, Symbol: '₹' };
                        }
                        return c;
                    });
                    setCurrencyList(list);
                } else {
                    setCurrencyList([]);
                }
            }
        } catch (err) {
            console.error('Error fetching currencies:', err);
        }
    };

    const fetchCompanySettings = async (isDuplicate = false) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    UserId: parseInt(userId, 10)
                }
            };
            const response = await fetch(GET_COMPANY_SETTING_DATA, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                const companySettings = Array.isArray(data?.Details?.settings) ? data.Details.settings : (Array.isArray(data?.d) ? data.d : []);

                const getVal = (key, section) => {
                    const found = companySettings.find(s =>
                        s.Key?.toLowerCase() === key.toLowerCase() &&
                        s.Section?.toLowerCase() === section.toLowerCase()
                    );
                    return found ? found.Value : '';
                };

                const prefix = getVal('NumberPrefix', 'invoice') || 'INV-654';
                const nextNumStr = getVal('NextNumber', 'invoice');
                const nextNum = parseInt(nextNumStr) || globalNextInvoiceNumber;
                // Match Webforms: pad using the length of NextNumber string itself if NumberDigit is 0
                const digits = nextNumStr ? nextNumStr.length : (parseInt(getVal('NumberDigit', 'invoice')) || 4);
                const finYearFormat = getVal('FinancialYearFormat', 'invoice') || 'YY/YY';
                const generatedNum = generateInvoiceNumber({
                    prefix,
                    nextNumber: nextNum,
                    numberDigits: digits,
                    financialYearFormat: finYearFormat
                });
                setEditView(prev => ({
                    ...prev,
                    CompanyName: getVal('LegalName', 'company') || prev?.CompanyName || '',
                    CompanyEmail: getVal('Email', 'company') || prev?.CompanyEmail || '',
                    CompanyPhone: getVal('Phone', 'company') || getVal('PhoneNumber', 'company') || prev?.CompanyPhone || '',
                    CompanyAddress: getVal('HeadOffice', 'company') || getVal('Address', 'company') || prev?.CompanyAddress || '',
                    CompanyCountryId: getVal('CountryId', 'company') || prev?.CompanyCountryId || '0',
                    CompanyStateId: getVal('StateId', 'company') || prev?.CompanyStateId || '0',
                    CompanyCityId: getVal('CityId', 'company') || prev?.CompanyCityId || '0',
                    CompanyPincode: getVal('Pincode', 'company') || prev?.CompanyPincode || '0',
                    CompanyLogo: getVal('Logo', 'company') || prev?.CompanyLogo || '',
                    CompanyTaxNumber: getVal('TaxNumber', 'company') || prev?.CompanyTaxNumber || '',
                    CompanyPanNumber: getVal('PanNumber', 'company') || prev?.CompanyPanNumber || '',
                    CompanyTermCondition: getVal('TermCondition', 'invoice') || prev?.CompanyTermCondition || '',
                }));

                const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                const pad = (n) => n < 10 ? '0' + n : n;
                const d1 = new Date();
                const validAfter = parseInt(getVal('PaymentDueDays', 'invoice')) || 30;
                const d2 = new Date(d1.getTime() + validAfter * 24 * 60 * 60 * 1000);
                const computedDueDate = `${pad(d2.getDate())}-${months[d2.getMonth()]}-${d2.getFullYear()}`;

                if (!isDuplicate) {
                    setEditForm(prev => ({
                        ...prev,
                        invoiceNumber: generatedNum,
                        dueDate: computedDueDate,
                        termsCondition: getVal('TermCondition', 'invoice') || '',
                        notes: getVal('Notes', 'invoice') || '',
                        footer: getVal('Footer', 'invoice') || '',
                        title: getVal('Title', 'invoice') || 'Invoice',
                        subheading: getVal('Subheading', 'invoice') || '',
                        placeOfOrigin: (['Berat', '1', ''].includes((getVal('State', 'company') || '').trim()) ? 'India' : (getVal('State', 'company') || 'India')),
                    }));
                } else {
                    setEditForm(prev => ({
                        ...prev,
                        invoiceNumber: generatedNum,
                        dueDate: computedDueDate
                    }));
                }
            }


        } catch (err) {
            console.error('Error fetching company settings:', err);
        }
    };

    const fetchLeadTax = async (leadId, autoPopulate = false) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const res = await fetch(LEAD_tax, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserId: parseInt(userId, 10), EntityId: parseInt(leadId, 10), Mode: 'Lead' })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setLeadTaxOptions(Array.isArray(list) ? list : []);

                // Auto-populate if requested and list is not empty
                if (autoPopulate && Array.isArray(list) && list.length > 0) {
                    const selected = list.find(o => o.IsDefault) || list[0];
                    if (selected) {
                        const taxNum = (selected.TaxNumber || '').trim();
                        const addr = selected.Address || '';
                        const pin = (selected.Pincode !== undefined && selected.Pincode !== null && selected.Pincode !== "") ? String(selected.Pincode) : "";
                        
                        const updateData = {
                            leadTax: selected.Id || selected.Code || selected.Value || '',
                            taxNumber: taxNum,
                            address: addr,
                            pincode: pin,
                            countryId: selected.CountryId || '',
                            stateId: selected.StateId || '',
                            cityId: selected.CityId || '',
                        };

                        setBillToForm(prev => ({ ...prev, ...updateData }));
                        
                        if (selected.CountryId) fetchCountries();
                        if (selected.CountryId) fetchStates(selected.CountryId);
                        if (selected.StateId) fetchCities(selected.StateId);
                    }
                }
            }
        } catch (e) { console.error('fetchLeadTax', e); }
    };

    const fetchCountries = async () => {
        if (countryOptions.length > 0) return;
        try {
            const res = await fetch(Get_country, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: {} })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setCountryOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchCountries', e); }
    };

    const fetchStates = async (countryId) => {
        setStateOptions([]); setCityOptions([]);
        try {
            const res = await fetch(Get_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(String(countryId), 10) } })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setStateOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchStates', e); }
    };

    const fetchCities = async (stateId) => {
        setCityOptions([]);
        try {
            // const GET_CITY_URL = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCityByState`;
            const res = await fetch(GET_CITY_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(String(stateId), 10) } })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setCityOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchCities', e); }
    };

    const fetchPreviewSuggestions = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = { Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } };
            const response = await fetch(Get_preview_list_edit, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Details || data?.Details || data?.d || data?.Data || [];
                setPreviewOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) {
            console.error('Error fetching preview suggestions:', e);
        }
    };

    // ─── Action Handlers ──────────────────────────────────────────────────────
    const openBillToModal = (d) => {
        const leadId = d.LeadId || d._invoice?.LeadId || '';
        const countryId = d.BillToCountryId || d.ContactCountryId || d.CountryId || '';
        const stateId = d.BillToStateId || d.ContactStateId || d.StateId || '';

        setBillToForm({
            company: d.CompanyName || '',
            name: d.ContactName || d.BillToName || '',
            email: d.ContactEmail || d.BillToEmailId || '',
            phone: d.ContactPhone || d.BillToPhoneNumber || '',
            taxNumber: (d.ContactTaxNumber || d.BillToTaxNumber || d.TaxNumber || '').trim(),
            panNumber: (d.ContactPanNumber || d.BillToPanNumber || d.PanNumber || '').trim(),
            address: d.ContactAddress || d.BillToAddress || '',
            countryId: countryId,
            countryName: d.BillToCountry || d.ContactCountry || d.Country || '',
            stateId: stateId,
            stateName: d.BillToState || d.ContactState || d.State || '',
            cityId: d.BillToCityId || d.ContactCityId || d.CityId || '',
            cityName: d.BillToCity || d.ContactCity || d.City || '',
            pincode: (d.BillToPincode !== undefined && d.BillToPincode !== null && d.BillToPincode !== "") ? String(d.BillToPincode) : (d.ContactPincode !== undefined && d.ContactPincode !== null && d.ContactPincode !== "") ? String(d.ContactPincode) : (d.Pincode || ''),
            leadTax: '',
        });

        if (countryId) fetchStates(countryId);
        if (stateId) fetchCities(stateId);
        fetchLeadTax(leadId, true);
        fetchCountries();
        setBillToOpen(true);
    };

    const openShipToModal = (invData) => {
        const countryId = invData.ShipToCountryId || invData.BillToCountryId || invData.ContactCountryId || invData.CountryId || '';
        const stateId = invData.ShipToStateId || invData.BillToStateId || invData.ContactStateId || invData.StateId || '';

        const sf = {
            company: invData.ShipToCompanyName || invData.CompanyName || '',
            name: safeStr(invData.ShipToName || invData.BillToName || invData.ContactName),
            email: safeStr(invData.ShipToEmailId || invData.BillToEmailId || invData.ContactEmail),
            phone: safeStr(invData.ShipToPhone || invData.BillToPhoneNumber || invData.ContactPhone),
            address: safeStr(invData.ShipToAddress || invData.BillToAddress || invData.ContactAddress),
            countryId: countryId,
            countryName: safeStr(invData.ShipToCountry || invData.BillToCountry || invData.ContactCountry || invData.Country),
            stateId: stateId,
            stateName: safeStr(invData.ShipToState || invData.BillToState || invData.ContactState || invData.State),
            cityId: safeStr(invData.ShipToCityId || invData.BillToCityId || invData.ContactCityId || invData.CityId),
            cityName: safeStr(invData.ShipToCity || invData.BillToCity || invData.ContactCity || invData.City),
            pincode: (invData.ShipToPincode !== undefined && invData.ShipToPincode !== null && invData.ShipToPincode !== "") ? String(invData.ShipToPincode) : (invData.BillToPincode !== undefined && invData.BillToPincode !== null && invData.BillToPincode !== "") ? String(invData.BillToPincode) : (invData.ContactPincode || invData.Pincode || ''),
        };

        setShipToForm(sf);
        if (countryId) fetchStates(countryId);
        if (stateId) fetchCities(stateId);
        fetchCountries();
        setShipToOpen(true);
    };

    const handleDeleteItem = (index) => {
        if (!editView) return;
        const newItems = [...(editView.invoiceItems || [])];
        newItems.splice(index, 1);
        setEditView(prev => ({ ...prev, invoiceItems: newItems }));
    };

    const handleApplyItemEdit = (index, field, value, type = 'existing') => {
        if (!editView) return;
        if (type === 'added') {
            const newItems = [...addedItems];
            if (newItems[index]) {
                newItems[index] = { ...newItems[index], [field]: value };
                setAddedItems(newItems);
            }
        } else {
            const newItems = [...(editView.invoiceItems || [])];
            if (newItems[index]) {
                newItems[index] = { ...newItems[index], [field]: value };
                setEditView(prev => ({ ...prev, invoiceItems: newItems }));
            }
        }
    };

    const handleSave = async () => {
        if (!editView) return;
        const d = editView;
        const errors = [];

        const b = billToForm;
        const s = isSameAsBillTo ? b : shipToForm;

        const checkValid = (id, name) => {
            const hasId = id !== undefined && id !== null && String(id) !== '0' && String(id).trim() !== '';
            const hasName = name !== undefined && name !== null && String(name).trim() !== '';
            return hasId || hasName;
        };

        if (!b.phone) errors.push("Mobile number is required for bill to.");
        if (!checkValid(b.countryId, b.countryName)) errors.push("Country is required for bill to.");
        if (!checkValid(b.stateId, b.stateName)) errors.push("State is required for bill to.");
        if (!checkValid(b.cityId, b.cityName)) errors.push("City is required for bill to.");

        if (!s.phone) errors.push("Mobile number is required for ship to.");
        if (!checkValid(s.countryId, s.countryName)) errors.push("Country is required for ship to.");
        if (!checkValid(s.stateId, s.stateName)) errors.push("State is required for ship to.");
        if (!checkValid(s.cityId, s.cityName)) errors.push("City is required for ship to.");

        if (errors.length > 0) {
            Swal.fire({
                title: 'Validation Failed',
                html: errors.join('<br/>'),
                icon: 'warning',
                confirmButtonColor: '#28a745'
            });
            return;
        }

        setSaveLoading(true);
        try {
            // Recalculate totals for payload (consistent with render)
            const lineItems = d.invoiceItems || [];
            const allItems = [
                ...lineItems.map((item, i) => ({ ...item, _key: `existing-${i}`, _type: 'existing', _idx: i })),
                ...addedItems.map((item, i) => ({ ...item, _key: `added-${i}`, _type: 'added', _idx: i })),
            ];

            let subTotal = 0;
            const itemsPayload = allItems.map(item => {
                const itemTotal = parseFloat(item.Total || 0);
                subTotal += itemTotal;
                const key = item._key;
                const disc = itemDiscounts[key] || { active: false, type: 'percentage', value: 0 };
                let itemDiscAmt = 0;
                if (disc.active && disc.value > 0) {
                    itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
                }
                const itemAfterDisc = itemTotal - itemDiscAmt;

                const taxCharges = [];
                // Existing taxes
                (item.invoiceItemTaxes || []).forEach(t => {
                    const rate = parseFloat(t.Rate || 0);
                    const amt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                    taxCharges.push({ TCName: t.Name, TCId: t.TaxId || '0', TCRate: rate, TCType: 'P', TCAmount: amt.toFixed(2) });
                });
                // Added taxes
                (itemAddedTaxes[key] || []).forEach(at => {
                    const amt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                    taxCharges.push({ TCName: at.Name, TCId: at.Id || '0', TCRate: at.Rate, TCType: at.Type === 'fixed' ? 'F' : 'P', TCAmount: amt.toFixed(2) });
                });

                const taxLabel = taxCharges.map(tc => `${tc.TCName} : ${tc.TCRate}${tc.TCType === 'P' ? '%' : ''}`).join(', ');
                const taxAmtLabel = taxCharges.map(tc => `${tc.TCName} : ${tc.TCAmount}`).join(', ');

                return {
                    ItemName: item.ItemName || item.Name || '',
                    ItemId: item.ItemId || item.Id || '0',
                    ItemSKU: String(item.ItemSKU || item.Sku || ''),
                    ItemDescription: item.ItemDescription || item.Description || '',
                    ItemHsnSacCode: item.ItemHsnSacCode || item.HSNCode || '',
                    ItemTax: taxLabel,
                    ItemTaxAmount: taxAmtLabel,
                    AdditionalEntities: {},
                    ItemVolume: parseInt(item.ItemVolume || item.Quantity || 1),
                    ItemPrice: parseFloat(item.ItemPrice || item.Price || item.SalePrice || 0),
                    ItemAmount: itemTotal.toFixed(2),
                    ItemTaxCharges: taxCharges
                };
            });

            const taxSum = itemsPayload.reduce((sum, itm) => {
                return sum + itm.ItemTaxCharges.reduce((s, tc) => s + parseFloat(tc.TCAmount), 0);
            }, 0);

            const totalDisc = allItems.reduce((sum, itm) => {
                const disc = itemDiscounts[itm._key];
                if (disc?.active) {
                    return sum + (disc.type === 'percentage' ? (parseFloat(itm.Total) * disc.value) / 100 : parseFloat(disc.value));
                }
                return sum;
            }, 0);

            const chargesTotal = addedCharges.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
            const grandTotal = subTotal - totalDisc + taxSum + chargesTotal;

            const invoiceBody = {
                InvoiceId: isDuplicateMode ? 0 : parseInt(d.Id || d.InvoiceId || 0, 10),
                BillToLeadId: d.LeadId || 0,
                BillToName: b.name || d.BillToName || '',
                BillToType: d.ContactType || b.name || '',
                BillToCompanyName: b.company || '',
                BillToTaxNumber: b.taxNumber || d.ContactTaxNumber || ' ',
                BillToEmailId: b.email || d.ContactEmail || '',
                BillToPhoneNumber: b.phone || d.ContactPhone || '',
                BillToAddress: b.address || d.ContactAddress || '',
                CompanyName: d.CompanyName || 'My Company',
                CompanyCountryId: String(d.CompanyCountryId || '0'),
                CompanyStateId: String(d.CompanyStateId || '0'),
                CompanyEmail: d.CompanyEmail || '',
                CompanyPhone: d.CompanyPhone || '',
                CompanyAddress: d.CompanyAddress || '',
                CompanyTaxNumber: d.CompanyTaxNumber || '',
                CompanyPanNumber: d.CompanyPanNumber || '',
                CurrencyId: String(selectedCurrency?.Id || d.CurrencyId || '2'),
                CompanyLogo: d.CompanyLogo || '',
                InvoiceTitle: editForm.title || '',
                InvoiceSubHeading: editForm.subheading || '',
                InvoiceNotes: editForm.notes || '',
                InvoiceFooter: editForm.footer || '',
                CompanyTermCondition: editForm.termsCondition || '',
                InvoiceNumber: editForm.invoiceNumber || '',
                BillToPanNumber: b.panNumber || d.ContactPanNumber || ' ',
                VariantsCollection: "",
                BillToCountryId: String(b.countryId || '0'),
                BillToStateId: String(b.stateId || '0'),
                BillToCityId: String(b.cityId || '0'),
                BillToPincode: String(b.pincode || '0'),
                ShipToName: s.name || '',
                ShipToCompanyName: s.company || '',
                ShipToEmailId: s.email || '',
                ShipToPhone: s.phone || '',
                ShipToAddress: s.address || '',
                ShipToCountryId: String(s.countryId || '0'),
                ShipToStateId: String(s.stateId || '0'),
                ShipToCityId: String(s.cityId || '0'),
                ShipToPincode: String(s.pincode || '0'),
                PlaceOfSupply: editForm.placeOfSupply || '',
                PlaceOfOrigin: editForm.placeOfOrigin || '',
                SalesOwner: parseInt(editForm.salesOwner || 0),
                InvoiceDate: formatDate(editForm.invoiceDate),
                InvoiceDueDate: formatDate(editForm.dueDate),
                InvoiceSubTotal: subTotal.toFixed(2),
                InvoiceTotal: grandTotal.toFixed(2),
                Items: itemsPayload,
                AdditionalItems: addedCharges.map(c => ({ Name: c.type, Amount: parseFloat(c.amount).toFixed(2) }))
            };

            const userId = localStorage.getItem('userId') || '34594';

            // 1. Validation Pre-flight: Check if Invoice Number already exists (Only for NEW records)
            if (editView?._isAdd) {
                let currentNum = editForm.invoiceNumber;
                let isUnique = false;
                let attempts = 0;

                while (!isUnique && attempts < 10) {
                    const valPayload = {
                        Token: "-2295521862261168",
                        Details: {
                            InvoiceNumber: currentNum || '',
                            UserId: parseInt(userId, 10)
                        }
                    };
                    const valResponse = await fetch(IS_INVOICE_ALREADY_GENERATED, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(valPayload)
                    });
                    
                    if (valResponse.ok) {
                        const valData = await valResponse.json();
                        const existsMsg = valData?.Details || valData?.d || "";
                        // If it's not empty string and not "Not Available", it's an error message saying it exists
                        if (existsMsg && existsMsg !== "" && existsMsg !== "Not Available") {
                            currentNum = generateDuplicateNumber(currentNum);
                            attempts++;
                        } else {
                            isUnique = true;
                        }
                    } else {
                        isUnique = true; // Proceed anyway or let main catch handle it
                    }
                }

                if (currentNum !== editForm.invoiceNumber) {
                    setEditForm(prev => ({ ...prev, invoiceNumber: currentNum }));
                    invoiceBody.InvoiceNumber = currentNum;

                    // Sync the global counter to avoid future collisions
                    const parts = currentNum.split('/');
                    const lastPart = parts[parts.length - 1];
                    if (!isNaN(lastPart) && lastPart.trim() !== "") {
                        globalNextInvoiceNumber = parseInt(lastPart, 10);
                    }
                }

                if (!isUnique) {
                    throw new Error("Could not generate a unique Invoice Number. Please enter one manually.");
                }
            }

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    InvoiceData: JSON.stringify(invoiceBody),
                    UserId: parseInt(userId, 10)
                }
            };

            const response = await fetch(INSERT_NEW_INVOICE_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.d === "Success" || resData?.Success || resData?.d === true || (typeof resData?.d === 'string' && resData?.d?.includes("Success"))) {

                    if (editView?._isAdd) {
                        globalNextInvoiceNumber++;
                        localStorage.setItem('lastInvoiceNumber', globalNextInvoiceNumber);
                    }

                    const successMsg = editView?._isAdd 
                        ? 'Invoice created successfully' 
                        : (isDuplicateMode ? 'Invoice duplicated successfully' : 'Invoice updated successfully');
                    Swal.fire({
                        title: 'Success',
                        text: successMsg,
                        icon: 'success',
                        confirmButtonColor: '#28a745'
                    });
                    setEditView(null);
                    if (fetchInvoices) fetchInvoices();
                } else {
                    throw new Error(resData?.d || 'Failed to save invoice');
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (err) {
            console.error('Save error:', err);
            Swal.fire({
                title: 'Error',
                text: err.message || 'Something went wrong while saving.',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        } finally {
            setSaveLoading(false);
        }
    };

    // Expose handlers to parent via ref
    useImperativeHandle(ref, () => ({
        handleEditInvoice: (inv) => handleEditInvoice(inv, false),
        handleDuplicateInvoice: (inv) => handleEditInvoice(inv, true),
        handleAddInvoice: (leadId) => handleAddInvoice(leadId)
    }));

    const handleEditInvoice = async (invoice, isDuplicate = false) => {
        setIsDuplicateMode(isDuplicate);
        setEditLoading(true);
        setCompanyOpen(false);
        setCustomerSearchOpen(false);
        setEditView({ _loading: true, _invoice: invoice });
        fetchOwners();
        fetchCurrencyList();

        try {
            const invoiceId = invoice.InvoiceId || invoice.ID || invoice.Id;
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    InvoiceId: parseInt(invoiceId, 10),
                    TimeZone: 'India Standard Time'
                }
            };
            const response = await fetch(GET_INVOICE_DETAILS_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const detail = data?.Details || data?.Details || data?.d || data?.Data || data?.data || data;
                setEditView({ ...detail, _invoice: invoice });

                if (detail.CurrencyId) {
                    const matchedCurrency = currencyList.find(c => String(c.Id) === String(detail.CurrencyId));
                    if (matchedCurrency) {
                        setSelectedCurrency(matchedCurrency);
                    } else {
                        setSelectedCurrency({ Id: detail.CurrencyId, Symbol: detail.CurrencySymbol === 'Rp' ? '₹' : (detail.CurrencySymbol || '$'), Name: detail.CurrencyName || 'Dollars' });
                    }
                }

                let defaultInvoiceDate = detail.InvoicedAt || '';
                let defaultDueDate = detail.DueAt || '';
                
                if (isDuplicate) {
                    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                    const pad = (n) => n < 10 ? '0' + n : n;
                    const d1 = new Date();
                    defaultInvoiceDate = `${pad(d1.getDate())}-${months[d1.getMonth()]}-${d1.getFullYear()}`;
                    
                    // WebForms keeps the DueAt same as original for duplicates (copies original)
                    defaultDueDate = detail.DueAt || '';
                }

                setEditForm({
                    title: detail.Title || 'Invoice',
                    subheading: detail.SubHeading || '',
                    placeOfSupply: detail.PlaceOfSupply || detail.CompanySupplyName || detail.ShipToState || detail.BillToState || '',
                    placeOfOrigin: (['Berat', '1'].includes(detail.PlaceOfOrigin || detail.CompanyOriginName || detail.CompanyState || detail.BillToState) ? 'India' : (detail.PlaceOfOrigin || detail.CompanyOriginName || detail.CompanyState || detail.BillToState || '')),
                    salesOwner: detail.SalesOwner || '',
                    invoiceNumber: isDuplicate ? '' : (detail.InvoiceNumber || ''),
                    invoiceDate: defaultInvoiceDate,
                    dueDate: defaultDueDate,
                    termsCondition: detail.CompanyTermCondition || '',
                    notes: detail.Notes || '',
                    footer: detail.Footer || '',
                });

                if (isDuplicate) {
                    fetchCompanySettings(true);
                }

                const ld = detail.leadDetail || {};
                const countryId = detail.BillToCountryId || detail.CountryId || detail.countryid || ld.CountryId || ld.countryid || '';
                const stateId = detail.BillToStateId || detail.StateId || detail.stateid || ld.StateId || ld.stateid || '';
                const cityId = detail.BillToCityId || detail.CityId || detail.cityid || ld.CityId || ld.cityid || '';

                const bf = {
                    company: detail.BillToCompanyName || ld.CompanyName || '',
                    name: detail.ContactName || ld.PersonName || '',
                    email: detail.ContactEmail || ld.EmailID || '',
                    phone: detail.ContactPhone || ld.MobileNo || '',
                    taxNumber: (detail.ContactTaxNumber || ld.TaxNumber || '').trim(),
                    panNumber: (detail.ContactPanNumber || ld.PanNumber || '').trim(),
                    address: detail.ContactAddress || ld.Address || '',
                    countryId: countryId,
                    countryName: detail.BillToCountry || detail.ContactCountry || ld.Country || '',
                    stateId: stateId,
                    stateName: detail.BillToState || detail.ContactState || ld.State || '',
                    cityId: cityId,
                    cityName: detail.BillToCity || detail.ContactCity || ld.City || '',
                    pincode: (detail.BillToPincode !== undefined && detail.BillToPincode !== null && detail.BillToPincode !== "") ? String(detail.BillToPincode) : (detail.ContactPincode || detail.Pincode || ld.PinCode || ''),
                    leadTax: '',
                };
                setBillToForm(bf);

                const sf = {
                    company: detail.ShipToCompanyName || ld.CompanyName || '',
                    name: detail.ShipToName || detail.ContactName || ld.PersonName || '',
                    email: detail.ShipToEmailId || detail.ContactEmail || ld.EmailID || '',
                    phone: detail.ShipToPhone || detail.ContactPhone || ld.MobileNo || '',
                    address: detail.ShipToAddress || detail.ContactAddress || ld.Address || '',
                    countryId: detail.ShipToCountryId || detail.countryid || countryId || '',
                    countryName: detail.ShipToCountry || detail.BillToCountry || ld.Country || '',
                    stateId: detail.ShipToStateId || detail.stateid || stateId || '',
                    stateName: detail.ShipToState || detail.BillToState || ld.State || '',
                    cityId: detail.ShipToCityId || detail.cityid || cityId || '',
                    cityName: detail.ShipToCity || detail.BillToCity || ld.City || '',
                    pincode: (detail.ShipToPincode !== undefined && detail.ShipToPincode !== null && detail.ShipToPincode !== "") ? String(detail.ShipToPincode) : (detail.BillToPincode || detail.ContactPincode || detail.Pincode || ld.PinCode || ''),
                };
                setShipToForm(sf);
                setIsSameAsBillTo(sf.address === bf.address && sf.pincode === bf.pincode);
            } else {
                setEditView({ _invoice: invoice, _fallback: true });
            }
        } catch (error) {
            console.error('Error fetching invoice for edit:', error);
            setEditView({ _invoice: invoice, _fallback: true });
        } finally {
            setEditLoading(false);
        }
    };

    const handleAddInvoice = (leadIdStr = null) => {
        setIsDuplicateMode(false); // New record
        setEditLoading(false);
        setCompanyOpen(false);
        setCustomerSearchOpen(false);

        // Signal a new add flow
        setEditView({ _isAdd: true });

        fetchOwners();
        fetchCurrencyList();
        fetchCompanySettings(false);

        const today = new Date();
        const tenDaysLater = new Date();
        tenDaysLater.setDate(today.getDate() + 10);

        // Reset Forms to defaults
        setEditForm({
            title: 'Invoice',
            subheading: '',
            placeOfSupply: '',
            placeOfOrigin: 'India',
            salesOwner: '',
            invoiceNumber: '',
            invoiceDate: formatDate(today),
            dueDate: formatDate(tenDaysLater),
            termsCondition: '',
            notes: '',
            footer: ''
        });

        const num = generateAddInvoiceNumber();
        if (num) {
            setEditForm(prev => ({ ...prev, invoiceNumber: num }));
        }

        setBillToForm({});
        setShipToForm({
            name: '', email: '', phone: '', address: '', countryId: '', countryName: '', stateId: '', stateName: '', cityId: '', cityName: '', pincode: ''
        });
        setIsSameAsBillTo(false);
        setAddedItems([]);
        setAddedCharges([]);
        setItemDiscounts({});
        setItemAddedTaxes({});

        if (leadIdStr) {
            handleSelectCustomer({ LeadId: leadIdStr });
            setCustomerSearchOpen(false);
        } else {
            // Automatically open customer search for a new invoice
            setCustomerSearchOpen(true);
            setCustomerSearchText('');
            setCustomerSuggestions([]);
        }
    };

    // ─── Render: Item Entity Modal ────────────────────────────────────────────
    const renderItemEntityModal = () => {
        if (!itemEntityModal.open) return null;
        return (
            <div className="billtto-modal-overlay" style={{ paddingTop: '80px' }}>
                <div className="billtto-modal" style={{ height: 'auto' }}>
                    <div className="billtto-modal-header">
                        <span>Edit Item Entity</span>
                        <button className="billtto-close-x" onClick={() => setItemEntityModal({ open: false, index: -1, value: '' })}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        <div className="billtto-field-group">
                            <input
                                className="billtto-input"
                                style={{ width: '100%', padding: '10px', border: '1px solid #3b82f6', borderRadius: '4px', outline: 'none' }}
                                value={itemEntityModal.value}
                                onChange={e => setItemEntityModal(prev => ({ ...prev, value: e.target.value }))}
                            />
                        </div>
                    </div>
                    <div className="billtto-modal-footer" style={{ justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="billtto-btn-close" onClick={() => setItemEntityModal({ open: false, index: -1, value: '' })}>Cancel</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            handleApplyItemEdit(itemEntityModal.index, 'Name', itemEntityModal.value, itemEntityModal.type);
                            setItemEntityModal({ open: false, index: -1, value: '', type: 'existing' });
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Item Description Modal ───────────────────────────────────────
    const renderItemDescriptionModal = () => {
        if (!itemDescModal.open) return null;



        const descQuillModules = {
            toolbar: [['bold', 'italic', 'underline']]
        };

        return (
            <div className="billtto-modal-overlay" style={{ paddingTop: '60px' }}>
                <div className="billtto-modal" style={{ width: '600px', height: 'auto' }}>
                    <div className="billtto-modal-header">
                        <span>Edit Item Description</span>
                        <button className="billtto-close-x" onClick={() => { setItemDescModal({ open: false, index: -1, value: '' }); }}>×</button>
                    </div>
                    <div className="billtto-modal-body" style={{ position: 'relative' }}>
                        <div className="item-description-editor-container">
                             <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '5px' }}>
                                <button 
                                    type="button" 
                                    className="billtto-btn-placeholder"
                                    style={{ 
                                        display: 'flex', alignItems: 'center', gap: '5px', 
                                        padding: '4px 8px', fontSize: '12px', background: '#f8fafc',
                                        border: '1px solid #e2e8f0', borderRadius: '4px', cursor: 'pointer'
                                    }}
                                    onClick={() => { fetchPlaceholders(); setPlaceholderModalOpen(true); }}
                                >
                                    <Settings size={14} /> Placeholder
                                </button>
                            </div>
                            <SafeQuill
                                ref={quillRef}
                                theme="snow"
                                value={itemDescModal.value}
                                onChange={(val) => setItemDescModal(prev => ({ ...prev, value: val }))}
                                modules={descQuillModules}
                                placeholder="Description"
                            />
                        </div>

                        {placeholderModalOpen && (
                            <div className="placeholder-mini-modal" style={{
                                position: 'absolute', top: '40px', right: '20px', zIndex: 100,
                                background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '280px'
                            }}>
                                <div style={{ 
                                    padding: '8px 12px', borderBottom: '1px solid #f1f5f9', 
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    background: '#f8fafc', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'
                                }}>
                                    <span style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', letterSpacing: '0.05em' }}>CHOOSE YOUR PLACEHOLDER</span>
                                    <button onClick={() => setPlaceholderModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#94a3b8' }}>×</button>
                                </div>
                                <div style={{ padding: '15px' }}>
                                    <select 
                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '13px', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value) handleInsertPlaceholder(e.target.value);
                                        }}
                                        value=""
                                    >
                                        <option value="" disabled>--Select Entity Placeholder--</option>
                                        {placeholderOptions.map((opt, i) => {
                                            const val = opt.Text || opt.Name || opt.TagName || opt.Value || (typeof opt === 'string' ? opt : '');
                                            if (!val) return null;
                                            return (
                                                <option key={i} value={val}>
                                                    {val}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        )}

                        {previewOptions.length > 0 && (
                            <div className="preview-suggestions-premium">
                                <div className="suggestion-label">SUGGESTIONS:</div>
                                <div className="suggestions-list">
                                    {previewOptions.slice(0, 5).map((opt, idx) => (
                                        <div key={idx} className="suggestion-bubble" onClick={() => setItemDescModal(prev => ({ ...prev, value: opt.Text || opt.Name || '' }))}>
                                            {opt.Text || opt.Name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="billtto-modal-footer" style={{ justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="billtto-btn-close" onClick={() => { setItemDescModal({ open: false, index: -1, value: '' }); }}>Cancel</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            handleApplyItemEdit(itemDescModal.index, 'Description', itemDescModal.value, itemDescModal.type);
                            setItemDescModal({ open: false, index: -1, value: '', type: 'existing' });
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Bill To Edit Modal ───────────────────────────────────────────
    const renderBillToModal = () => {
        if (!billToOpen) return null;
        const bf = billToForm;
        const upd = (key, val) => setBillToForm(prev => ({ ...prev, [key]: val }));

        const handleCountryChange = (e) => {
            const val = e.target.value;
            const opt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === val);
            upd('countryId', val);
            upd('countryName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('stateId', ''); upd('stateName', '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchStates(val);
        };
        const handleStateChange = (e) => {
            const val = e.target.value;
            const opt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === val);
            upd('stateId', val);
            upd('stateName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchCities(val);
        };
        const handleCityChange = (e) => {
            const val = e.target.value;
            const opt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === val);
            upd('cityId', val);
            upd('cityName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
        };

        return (
            <div className="billtto-modal-overlay" onClick={() => setBillToOpen(false)}>
                <div className="billtto-modal" onClick={e => e.stopPropagation()}>
                    <div className="billtto-modal-header">
                        <span>Edit your lead address</span>
                        <button className="billtto-close-x" onClick={() => setBillToOpen(false)}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        {/* Lead Tax */}
                        <div className="billtto-field-group">
                            <label>Lead Tax</label>
                            <div className="billtto-select-wrap">
                                <span className="billtto-icon">☰</span>
                                <select
                                    value={bf.leadTax || ''}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        upd('leadTax', val);
                                        const selected = leadTaxOptions.find(o => String(o.Id || o.Code || o.Value || '') === val);
                                        if (selected) {
                                            const taxNum = (selected.TaxNumber || '').trim();
                                            upd('taxNumber', taxNum);
                                            if (selected.Address) upd('address', selected.Address);
                                            if (selected.Pincode) upd('pincode', selected.Pincode);
                                            
                                            if (selected.CountryId) {
                                                upd('countryId', selected.CountryId);
                                                const cOpt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === String(selected.CountryId));
                                                if (cOpt) upd('countryName', cOpt.Text || cOpt.Name || '');
                                                fetchStates(selected.CountryId);
                                            }
                                            if (selected.StateId) {
                                                upd('stateId', selected.StateId);
                                                const sOpt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === String(selected.StateId));
                                                if (sOpt) upd('stateName', sOpt.Text || sOpt.Name || '');
                                                fetchCities(selected.StateId);
                                            }
                                            if (selected.CityId) {
                                                upd('cityId', selected.CityId);
                                                const ctOpt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === String(selected.CityId));
                                                if (ctOpt) upd('cityName', ctOpt.Text || ctOpt.Name || '');
                                            }
                                        }
                                    }}
                                    className="billtto-select"
                                >
                                    <option value="">Nothing selected</option>
                                    {leadTaxOptions.map((o, i) => (
                                        <option key={i} value={o.Id || o.Code || o.Value || ''}>
                                            {o.TaxNumber || o.Text || o.Name || o.Name1 || o.Value || String(i)}
                                        </option>
                                    ))}
                                </select>
                                <span className="billtto-arrow">▼</span>
                            </div>
                        </div>

                        {/* Company Name */}
                        <div className="billtto-field-group">
                            <label>Company Name</label>
                            <div className="billtto-input-wrap">
                                <span className="billtto-icon">🏢</span>
                                <input placeholder="Enter Company Name" value={bf.company || ''} onChange={e => upd('company', e.target.value)} />
                            </div>
                        </div>

                        {/* Name + Tax Number */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Name</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">👤</span>
                                    <input placeholder="Name" value={bf.name || ''} onChange={e => upd('name', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Tax Number</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">%</span>
                                    <input placeholder="Tax Number" value={bf.taxNumber || ''} onChange={e => upd('taxNumber', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Email + Phone */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Email</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">✉</span>
                                    <input placeholder="Enter Email" value={bf.email || ''} onChange={e => upd('email', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Phone</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">📞</span>
                                    <input placeholder="Phone" value={bf.phone || ''} onChange={e => upd('phone', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Country */}
                        <div className="billtto-field-group">
                            <label>Country</label>
                            <div className="billtto-select-wrap">
                                <span className="billtto-icon">🌐</span>
                                <select value={bf.countryId || ''} onChange={handleCountryChange} className="billtto-select" style={{ color: '#334155' }}>
                                    <option value="">--- Select Country ---</option>
                                    {countryOptions.map((o, i) => (
                                        <option key={i} value={o.Id || o.Code || o.Value || o.countryid || ''}>
                                            {o.Text || o.Name || o.Name1 || o.Value || o.countryname || ''}
                                        </option>
                                    ))}
                                </select>
                                <span className="billtto-arrow">▼</span>
                            </div>
                        </div>

                        {/* State + City */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>State</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={bf.stateId || ''} onChange={handleStateChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">--- Select State ---</option>
                                        {stateOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.stateid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.statename || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>City</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={bf.cityId || ''} onChange={handleCityChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">--- Select City ---</option>
                                        {cityOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.cityid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.cityname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* Pincode + Pan Number */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Pincode</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <input placeholder="Enter Pincode" value={bf.pincode || ''} onChange={e => upd('pincode', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Pan Number</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <input placeholder="Enter Pan Number" value={bf.panNumber || ''} onChange={e => upd('panNumber', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Address */}
                        <div className="billtto-field-group">
                            <label>Address</label>
                            <textarea className="billtto-textarea" placeholder="Address" value={bf.address || ''} onChange={e => upd('address', e.target.value)} rows={3} />
                        </div>
                    </div>

                    <div className="billtto-modal-footer">
                        <button className="billtto-btn-close" onClick={() => setBillToOpen(false)}>Close</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            if (billToForm.stateName) {
                                setEditForm(prev => ({ ...prev, placeOfOrigin: billToForm.stateName }));
                            }
                            setBillToOpen(false);
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Ship To Edit Modal ───────────────────────────────────────────
    const renderShipToModal = () => {
        if (!shipToOpen) return null;
        const sf = shipToForm;
        const upd = (key, val) => setShipToForm(prev => ({ ...prev, [key]: val }));

        const handleCountryChange = (e) => {
            const val = e.target.value;
            const opt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === val);
            upd('countryId', val);
            upd('countryName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('stateId', ''); upd('stateName', '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchStates(val);
        };
        const handleStateChange = (e) => {
            const val = e.target.value;
            const opt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === val);
            upd('stateId', val);
            upd('stateName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchCities(val);
        };
        const handleCityChange = (e) => {
            const val = e.target.value;
            const opt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === val);
            upd('cityId', val);
            upd('cityName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
        };

        return (
            <div className="billtto-modal-overlay" onClick={() => setShipToOpen(false)}>
                <div className="billtto-modal" onClick={e => e.stopPropagation()}>
                    <div className="billtto-modal-header">
                        <span>Edit ShipTo</span>
                        <button className="billtto-close-x" onClick={() => setShipToOpen(false)}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        {/* Company Name */}
                        <div className="billtto-field-group">
                            <label>Company Name</label>
                            <div className="billtto-input-wrap">
                                <span className="billtto-icon">🏢</span>
                                <input placeholder="Enter Company Name" value={sf.company || ''} onChange={e => upd('company', e.target.value)} />
                            </div>
                        </div>

                        {/* Name + Email */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Name</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">👤</span>
                                    <input placeholder="Name" value={sf.name || ''} onChange={e => upd('name', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Email</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">✉</span>
                                    <input placeholder="Enter Email" value={sf.email || ''} onChange={e => upd('email', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Phone + Country */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Phone</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">📞</span>
                                    <input placeholder="Phone" value={sf.phone || ''} onChange={e => upd('phone', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Country</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.countryId || ''} onChange={handleCountryChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {countryOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.countryid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.countryname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* State + City */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>State</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.stateId || ''} onChange={handleStateChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {stateOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.stateid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.statename || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>City</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.cityId || ''} onChange={handleCityChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {cityOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.cityid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.cityname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* Pincode */}
                        <div className="billtto-field-group">
                            <label>Pincode</label>
                            <div className="billtto-input-wrap" style={{ width: '50%' }}>
                                <span className="billtto-icon">🌐</span>
                                <input placeholder="Enter Pincode" value={sf.pincode || ''} onChange={e => upd('pincode', e.target.value)} />
                            </div>
                        </div>

                        {/* Address */}
                        <div className="billtto-field-group">
                            <label>Address</label>
                            <textarea className="billtto-textarea" placeholder="Address" value={sf.address || ''} onChange={e => upd('address', e.target.value)} rows={3} />
                        </div>
                    </div>

                    <div className="billtto-modal-footer">
                        <button className="billtto-btn-close" onClick={() => setShipToOpen(false)}>Close</button>
                        <button className="billtto-btn-apply" style={{ background: '#84cc16' }} onClick={() => {
                            if (sf.stateName) {
                                setEditForm(prev => ({
                                    ...prev,
                                    placeOfSupply: sf.stateName
                                }));
                            }
                            Swal.fire({
                                title: 'Success',
                                text: 'Shipped address updated',
                                icon: 'success',
                                confirmButtonColor: '#16a34a'
                            });
                            setShipToOpen(false);
                        }}>Save</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Invoice Edit Panel ───────────────────────────────────────────
    const renderEditPanel = () => {
        if (!editView) return null;
        const d = editView;
        const leadDetail = d.leadDetail || {};
        const customerName = leadDetail.PersonName || d.ContactName || '-';
        const lineItems = d.invoiceItems || [];
        const companyName = d.CompanyName || '-';
        const companyLogo = d.CompanyLogo || '';
        const logoInitial = companyName !== '-' ? companyName[0].toUpperCase() : 'U';

        // Combine existing + added items into unified list
        const allItems = [
            ...lineItems.map((item, i) => ({ ...item, _key: `existing-${i}`, _type: 'existing', _idx: i })),
            ...addedItems.map((item, i) => ({ ...item, _key: `added-${i}`, _type: 'added', _idx: i })),
        ];

        let subTotal = 0;
        const allTaxSummary = {}; // { taxName: totalAmount }
        allItems.forEach(item => {
            const itemTotal = parseFloat(item.Total || 0);
            subTotal += itemTotal;
            const key = item._key;
            const disc = getDiscount(key);
            let itemDiscAmt = 0;
            if (disc.active && disc.value > 0) {
                itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
            }
            const itemAfterDisc = itemTotal - itemDiscAmt;

            // Existing taxes
            (item.invoiceItemTaxes || []).forEach(t => {
                const rate = parseFloat(t.Rate || 0);
                const amt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                allTaxSummary[t.Name] = (allTaxSummary[t.Name] || 0) + amt;
            });

            // Added taxes
            (itemAddedTaxes[key] || []).forEach(at => {
                const amt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                allTaxSummary[at.Name] = (allTaxSummary[at.Name] || 0) + amt;
            });
        });

        const totalDiscount = allItems.reduce((s, item) => {
            const disc = getDiscount(item._key);
            if (!disc.active || disc.value <= 0) return s;
            return s + (disc.type === 'percentage' ? (parseFloat(item.Total || 0) * disc.value) / 100 : parseFloat(disc.value) || 0);
        }, 0);

        const taxTotal = Object.values(allTaxSummary).reduce((s, v) => s + v, 0);
        const chargesTotal = addedCharges.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
        const grandTotal = subTotal - totalDiscount + taxTotal + chargesTotal;
        let currencySymbol = selectedCurrency?.Symbol || d.CurrencySymbol || '$';
        if (currencySymbol === 'Rp') currencySymbol = '₹';
        const stripHtml = (html) => (html || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

        const safeStrLocal = (val, fallback = '-') => {
            if (!val) return fallback;
            if (typeof val === 'string') return val || fallback;
            if (typeof val === 'object') return val.Text || val.Code || val.Name || val.Value || String(val.Id || '') || fallback;
            return String(val) || fallback;
        };

        return (
            <div className="invoice-edit-overlay" onClick={() => setEditView(null)}>
                <div className="invoice-edit-panel" onClick={(e) => e.stopPropagation()}>

                    {/* Row 1: Navigation Row */}
                    <div className="edit-nav-row">
                        <div className="edit-back-link" onClick={() => setEditView(null)}>
                            <X size={20} />
                            <span>Back to Invoice</span>
                        </div>
                    </div>

                    {/* Row 2: Title Row */}
                    <div className="edit-back-bar">
                        <div className="edit-back-bar-left">
                            <span className="edit-panel-title">New Invoice</span>
                        </div>
                    </div>

                    {editLoading ? (
                        <div style={{ padding: '40px' }}><Loader message="Loading invoice..." /></div>
                    ) : (
                        <div className="edit-content" style={{ position: 'relative' }}>
                            {saveLoading && (
                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.7)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Loader message="Saving invoice..." />
                                </div>
                            )}
                            <div className={`edit-company-bar ${companyOpen ? 'open' : ''}`}
                                onClick={() => setCompanyOpen(!companyOpen)}>
                                <div className="edit-company-initial">
                                    {companyOpen ? <ChevronDown size={20} /> : <ChevronRight size={18} />}
                                </div>
                                <span className="edit-company-label">Company</span>
                            </div>

                            {/* ── Expanded Company Section ── */}
                            {companyOpen && (
                                <div className="edit-company-section">
                                    <div className="edit-logo-row">
                                        <div className="edit-logo-avatar">
                                            {companyLogo
                                                ? <img src={companyLogo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                                : <span>{logoInitial}</span>}
                                        </div>
                                        <button className="edit-logo-remove">remove</button>
                                    </div>

                                    <div className="edit-form-grid-2">
                                        <div className="edit-form-group">
                                            <label>Title</label>
                                            <input type="text" placeholder="Invoice" value={editForm.title || ''} onChange={(e) => setEditForm({ ...editForm, title: e.target.value })} />
                                        </div>
                                        <div className="edit-form-group">
                                            <label>Subheading</label>
                                            <input type="text" placeholder="This is your Invoice" value={editForm.subheading || ''} onChange={(e) => setEditForm({ ...editForm, subheading: e.target.value })} />
                                        </div>
                                    </div>



                                    <div className="edit-company-info">
                                        <div className="edit-company-name" style={{ fontWeight: 700, fontSize: '15px', color: '#1e293b', marginBottom: '4px' }}>{safeStrLocal(companyName)}</div>
                                        <div className="edit-company-detail">✉ {safeStrLocal(d.CompanyEmail || d.Email)}</div>
                                        <div className="edit-company-detail">☎ {safeStrLocal(d.CompanyPhone || d.Mobile || d.PhoneNumber)}</div>
                                        <div className="edit-company-detail">📍 {safeStrLocal(d.CompanyAddress || d.Address)}</div>
                                        {(d.CompanyTaxNumber || d.GSTNumber) && (
                                            <div className="edit-company-detail" style={{ fontWeight: 500 }}>
                                                % Tax Number: {safeStrLocal(d.CompanyTaxNumber || d.GSTNumber)}
                                            </div>
                                        )}
                                        {(d.CompanyPanNumber || d.PanNumber) && (
                                            <div className="edit-company-detail" style={{ fontWeight: 500 }}>
                                                % Pan Number: {safeStrLocal(d.CompanyPanNumber || d.PanNumber)}
                                            </div>
                                        )}
                                        <a href="#0" className="edit-company-edit-link">Edit your business address</a>
                                    </div>

                                    <div className="edit-form-group" style={{ marginTop: 16 }}>
                                        <label>Sales Owner</label>
                                        <select value={editForm.salesOwner || ''} onChange={(e) => setEditForm({ ...editForm, salesOwner: e.target.value })} className="edit-select">
                                            <option value="">Nothing selected</option>
                                            {ownerOptions.map((o, i) => (
                                                <option key={i} value={o.Code || o.UserId || o.Id || ''}>
                                                    {o.Text || o.Name || o.FullName || String(i)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            {/* ── Main Edit Form (visible when company closed) ── */}
                            {!companyOpen && (
                                <div className="edit-main-form">
                                    <div className="edit-top-grid">
                                        {/* Bill To */}
                                        <div className="edit-bill-box">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <span style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>Bill To</span>
                                                {(!editView?._isAdd || ((billToForm.name || d.BillToName || d.ContactName || customerName) && (billToForm.name || d.BillToName || d.ContactName || customerName) !== '-')) && (
                                                    <button onClick={() => openBillToModal(d)} title="Edit lead address" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3b82f6', padding: '2px 4px', display: 'flex', alignItems: 'center' }}><Edit3 size={14} /></button>
                                                )}
                                            </div>

                                            {/* Customer search input */}
                                            {customerSearchOpen && (
                                                <div className="customer-search-container">
                                                    <input
                                                        type="text"
                                                        className="customer-search-input"
                                                        placeholder="Type a Customer name"
                                                        value={customerSearchText}
                                                        onChange={(e) => {
                                                            setCustomerSearchText(e.target.value);
                                                            fetchCustomerSuggestions(e.target.value);
                                                        }}
                                                        autoFocus
                                                    />
                                                    {customerSuggestions.length > 0 && (
                                                        <div className="customer-suggestions-dropdown">
                                                            {customerSuggestions.map((cust, ci) => {
                                                                const name = cust.PersonName || cust.Name || '-';
                                                                const profileImg = cust.ProfileImgFileName || cust.ProfileImage || cust.Image || '';
                                                                const isDefaultAvatar = !profileImg || profileImg.includes('img_avatar1.png') || profileImg.includes('avatar');
                                                                
                                                                const getInitials = (str) => {
                                                                    if (!str) return 'U';
                                                                    const cleanStr = str.replace(/^[^a-zA-Z0-9]+/, '');
                                                                    if (!cleanStr) return 'U';
                                                                    if (/^\d/.test(cleanStr)) return cleanStr.substring(0, 2);
                                                                    const words = cleanStr.trim().split(/\s+/);
                                                                    if (words.length >= 2) return (words[0][0] + (words[1][0] || '')).toUpperCase();
                                                                    return words[0][0].toUpperCase();
                                                                };

                                                                const getAvatarColors = (str) => {
                                                                    const pairs = [
                                                                        { bg: '#fef9c3', text: '#a16207' }, // Yellow
                                                                        { bg: '#dbeafe', text: '#1e40af' }, // Blue
                                                                        { bg: '#dcfce7', text: '#166534' }, // Green
                                                                        { bg: '#f3e8ff', text: '#6b21a8' }, // Purple
                                                                        { bg: '#fce7f3', text: '#9d174d' }, // Pink
                                                                        { bg: '#ffedd5', text: '#9a3412' }, // Orange
                                                                        { bg: '#e0f2fe', text: '#0369a1' }, // Sky
                                                                    ];
                                                                    const index = (str || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % pairs.length;
                                                                    return pairs[index];
                                                                };
                                                                const avatarColor = getAvatarColors(name);

                                                                return (
                                                                    <div key={cust.LeadId || cust.Id || ci} className="customer-suggestion-item" onClick={() => handleSelectCustomer(cust)}>
                                                                        <div className="customer-suggestion-avatar" style={{ borderRadius: '50%', overflow: 'hidden', backgroundColor: avatarColor.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            {!isDefaultAvatar
                                                                                ? <img src={profileImg} alt="" className="customer-avatar-img" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                                : <span className="customer-avatar-initial" style={{ fontSize: 13, fontWeight: 700, color: avatarColor.text }}>{getInitials(name)}</span>
                                                                            }
                                                                        </div>
                                                                        <div className="customer-suggestion-info">
                                                                            <div className="customer-suggestion-name" style={{ fontWeight: 700, fontSize: 14 }}>{name}</div>
                                                                            {(cust.MobileNo || cust.Mobile || cust.Phone) && (
                                                                                <div className="customer-suggestion-detail" style={{ color: '#ec4899', fontWeight: 500 }}>📞 {cust.MobileNo || cust.Mobile || cust.Phone}</div>
                                                                            )}
                                                                            {(cust.EmailID || cust.Email || cust.EmailId) && (
                                                                                <div className="customer-suggestion-detail">✉ {cust.EmailID || cust.Email || cust.EmailId}</div>
                                                                            )}
                                                                            {(cust.CompanyName) && (
                                                                                <div className="customer-suggestion-detail">🏢 {cust.CompanyName}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Show customer details or Add a Customer */}
                                            {!customerSearchOpen && (
                                                (!editView?._isAdd || ((billToForm.name || d.BillToName || d.ContactName || customerName) && (billToForm.name || d.BillToName || d.ContactName || customerName) !== '-')) ? (
                                                    <>
                                                        <div className="edit-bill-name" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                            {billToForm.company || d.CompanyName || billToForm.name || d.BillToName || d.ContactName || customerName || 'Customer'}
                                                        </div>
                                                        {(billToForm.company || d.CompanyName) && (billToForm.name || d.BillToName || d.ContactName) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.name || d.BillToName || d.ContactName}</div>
                                                        )}
                                                        {(billToForm.email || d.ContactEmail) && <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.email || d.ContactEmail}</div>}
                                                        {(billToForm.taxNumber || d.BillToTaxNumber || d.ContactTaxNumber?.trim()) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>Tax Number: {billToForm.taxNumber || d.BillToTaxNumber || d.ContactTaxNumber}</div>
                                                        )}
                                                        {(billToForm.panNumber || d.BillToPanNumber || d.ContactPanNumber?.trim()) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>Pan Number: {billToForm.panNumber || d.BillToPanNumber || d.ContactPanNumber}</div>
                                                        )}
                                                        <div className="edit-bill-line" style={{ color: '#64748b' }}>
                                                            {billToForm.address || d.ContactAddress || '.'}, {billToForm.cityName || d.BillToCity || ''}, {billToForm.stateName || d.BillToState || ''}, {billToForm.countryName || d.BillToCountry || ''}, {billToForm.pincode || d.BillToPincode || '0'}
                                                        </div>
                                                        {editView?._isAdd && (
                                                            <a href="#0" className="edit-choose-link" onClick={(e) => { e.preventDefault(); setCustomerSearchOpen(true); setCustomerSearchText(''); setCustomerSuggestions([]); }}>Choose a different customer</a>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="add-customer-card" onClick={() => { setCustomerSearchOpen(true); setCustomerSearchText(''); setCustomerSuggestions([]); }}>
                                                        <div className="add-customer-icon">👤</div>
                                                        <span className="add-customer-text">Add a Customer</span>
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        {/* Ship To */}
                                        <div className="edit-bill-box">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>Ship To</span>
                                                    <label style={{ fontSize: 11, color: '#64748b', fontWeight: 400, display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                                                        <input type="checkbox" checked={isSameAsBillTo} onChange={(e) => setIsSameAsBillTo(e.target.checked)} style={{ width: 13, height: 13 }} />
                                                        Same as Bill To
                                                    </label>
                                                </div>
                                                {(!editView?._isAdd || (isSameAsBillTo 
                                                    ? ((billToForm.name || d.BillToName || d.ContactName || customerName) && (billToForm.name || d.BillToName || d.ContactName || customerName) !== '-') 
                                                    : ((shipToForm.name || d.ShipToName || customerName) && (shipToForm.name || d.ShipToName || customerName) !== '-'))) && (
                                                    <button onClick={() => openShipToModal(d)} title="Edit shipping address" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3b82f6', padding: '2px 4px', display: 'flex', alignItems: 'center' }}><Edit3 size={14} /></button>
                                                )}
                                            </div>

                                            {((isSameAsBillTo 
                                                ? (billToForm.name || d.BillToName || d.ContactName || customerName) 
                                                : (shipToForm.name || d.ShipToName || customerName)) && (isSameAsBillTo 
                                                ? (billToForm.name || d.BillToName || d.ContactName || customerName) 
                                                : (shipToForm.name || d.ShipToName || customerName)) !== '-') && (
                                                <>
                                                    {isSameAsBillTo ? (
                                                        <>
                                                            <div className="edit-bill-name" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                                {billToForm.company || d.CompanyName || billToForm.name || d.BillToName || d.ContactName || customerName}
                                                            </div>
                                                            {(billToForm.company || d.CompanyName) && (billToForm.name || d.BillToName || d.ContactName) && (
                                                                <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.name || d.BillToName || d.ContactName}</div>
                                                            )}
                                                            {(billToForm.email || d.ContactEmail) && <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.email || d.ContactEmail}</div>}
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>
                                                                {[billToForm.address || d.ContactAddress, billToForm.cityName || d.BillToCity, billToForm.stateName || d.BillToState, billToForm.countryName || d.BillToCountry, billToForm.pincode || d.BillToPincode].filter(p => p && p !== '.').join(', ') || ''}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="edit-bill-name" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                                {shipToForm.company || (d.ShipToName && d.ShipToName !== d.ContactName ? d.ShipToName : '') || shipToForm.name || customerName}
                                                            </div>
                                                            {(shipToForm.company) && (shipToForm.name || d.ShipToName) && (
                                                                <div className="edit-bill-line" style={{ color: '#64748b' }}>{shipToForm.name || d.ShipToName}</div>
                                                            )}
                                                            {(shipToForm.email || d.ShipToEmailId) && <div className="edit-bill-line" style={{ color: '#64748b' }}>{shipToForm.email || d.ShipToEmailId}</div>}
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>
                                                                {[shipToForm.address || d.ShipToAddress, shipToForm.cityName || d.ShipToCity, shipToForm.stateName || d.ShipToState, shipToForm.countryName || d.ShipToCountry, shipToForm.pincode || d.ShipToPincode].filter(p => p && p !== '.').join(', ') || ''}
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        {/* Invoice Number + Dates */}
                                        <div className="edit-invoice-meta">
                                            <div className="edit-form-group">
                                                <label>Invoice Number</label>
                                                <input
                                                    type="text"
                                                    value={editForm.invoiceNumber || ''}
                                                    onChange={(e) => setEditForm({ ...editForm, invoiceNumber: e.target.value })}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#64748b' }}
                                                />
                                            </div>
                                            <div className="edit-form-grid-2" style={{ marginTop: 12 }}>
                                                <div className="edit-form-group">
                                                    <label>Invoice Date</label>
                                                    <input type="text" value={editForm.invoiceDate || ''} onChange={(e) => setEditForm({ ...editForm, invoiceDate: e.target.value })} />
                                                </div>
                                                <div className="edit-form-group">
                                                    <label>Payment Due Date</label>
                                                    <input type="text" value={editForm.dueDate || ''} onChange={(e) => setEditForm({ ...editForm, dueDate: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Place of Supply / Origin / Currency */}
                                    <div className="edit-supply-row">
                                        <div className="edit-supply-item">
                                            <label>Place of Supply :</label>
                                            <input type="text" value={editForm.placeOfSupply || ''} onChange={(e) => setEditForm({ ...editForm, placeOfSupply: e.target.value })} />
                                        </div>
                                        <div className="edit-supply-item">
                                            <label>Place of Origin :</label>
                                            <div className="edit-input-group">
                                                <input type="text" value={editForm.placeOfOrigin || ''} onChange={(e) => setEditForm({ ...editForm, placeOfOrigin: e.target.value })} />
                                                <button className="edit-input-btn"><Edit3 size={14} /></button>
                                            </div>
                                        </div>
                                        <div className="edit-supply-item">
                                            <label>Currency</label>
                                            <div className="edit-currency-wrap">
                                                <div className="edit-currency-icon"><Banknote size={16} /></div>
                                                <select
                                                    className="edit-currency-select"
                                                    value={selectedCurrency?.Id || d.CurrencyId || ''}
                                                    onChange={(e) => {
                                                        const curr = currencyList.find(c => String(c.Id) === e.target.value);
                                                        if (curr) setSelectedCurrency(curr);
                                                    }}
                                                >
                                                    {currencyList.length === 0 && (
                                                        <option value={d.CurrencyId || ''}>{d.CurrencyName || 'Dollars'} ({d.CurrencySymbol === 'Rp' ? '₹' : (d.CurrencySymbol || '$')})</option>
                                                    )}
                                                    {currencyList.map(c => (
                                                        <option key={c.Id} value={c.Id}>{c.Name} ({c.Symbol})</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items Table */}
                                    <div className="edit-items-section">
                                        <table className="edit-items-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 28 }}></th>
                                                    <th>Model</th>
                                                    <th>Preview</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Amount</th>
                                                    <th>HSN/SAC Code</th>
                                                    <th>Taxes</th>
                                                    <th>TaxAmount</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {allItems.length > 0 ? allItems.map((item) => {
                                                    const itemKey = item._key;
                                                    const itemTaxes = item.invoiceItemTaxes || [];
                                                    const disc = getDiscount(itemKey);
                                                    const itemTotal = parseFloat(item.Total || 0);
                                                    let itemDiscAmt = 0;
                                                    if (disc.active && disc.value > 0) {
                                                        itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
                                                    }
                                                    const itemAfterDisc = itemTotal - itemDiscAmt;
                                                    const perItemAddedTaxes = itemAddedTaxes[itemKey] || [];
                                                    const isTaxSearchOpen = itemTaxSearchOpen[itemKey] || false;

                                                    return (
                                                        <React.Fragment key={itemKey}>
                                                            <tr className="edit-item-row">
                                                                <td><span className="drag-handle"><GripVertical size={14} /></span></td>
                                                                <td>
                                                                    <div className="edit-item-cell">
                                                                        <span>{item.Name || '-'}</span>
                                                                        <button className="edit-item-pencil" onClick={() => setItemEntityModal({ open: true, index: item._idx, value: item.Name || '', type: item._type })}><Edit3 size={12} /></button>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="edit-item-cell">
                                                                        <span className="text-truncate edit-description-html" style={{ maxWidth: '150px' }} dangerouslySetInnerHTML={{ __html: item.Description || '-' }}></span>
                                                                        <button className="edit-item-pencil" onClick={() => {
                                                                            setItemDescModal({ open: true, index: item._idx, value: item.Description || '', type: item._type });
                                                                            fetchPreviewSuggestions();
                                                                        }}><Edit3 size={12} /></button>
                                                                    </div>
                                                                </td>
                                                                <td>{item.Quantity || 1}</td>
                                                                <td>{currencySymbol} {parseFloat(item.Price || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                <td>{currencySymbol} {itemTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                <td>{item.ItemHsnSacCode ? `HSN: ${item.ItemHsnSacCode}` : '-'}</td>
                                                                <td>{item.ItemTax || '-'}</td>
                                                                <td>{item.ItemTaxAmount || '-'}</td>
                                                                <td>
                                                                    <button className="edit-item-delete" onClick={() => {
                                                                        if (item._type === 'added') handleDeleteAddedItem(item._idx);
                                                                        else handleDeleteItem(item._idx);
                                                                    }}><Trash2 size={14} /></button>
                                                                </td>
                                                            </tr>

                                                            {/* Discount row for this item */}
                                                            {disc.active && (
                                                                <tr className="tax-subrow discount-subrow">
                                                                    <td></td>
                                                                    <td colSpan="2" style={{ fontWeight: 600, color: '#475569' }}>Discount</td>
                                                                    <td colSpan="2">
                                                                        <div className="discount-toggle-wrap">
                                                                            <label className={`discount-radio-label ${disc.type === 'percentage' ? 'active' : ''}`}>
                                                                                <input type="radio" name={`discType-${itemKey}`} checked={disc.type === 'percentage'} onChange={() => setDiscountForItem(itemKey, prev => ({ ...prev, type: 'percentage' }))} />
                                                                                <span className="discount-radio-icon">%</span>
                                                                            </label>
                                                                            <label className={`discount-radio-label ${disc.type === 'rupees' ? 'active' : ''}`}>
                                                                                <input type="radio" name={`discType-${itemKey}`} checked={disc.type === 'rupees'} onChange={() => setDiscountForItem(itemKey, prev => ({ ...prev, type: 'rupees' }))} />
                                                                                <span className="discount-radio-icon">₹</span>
                                                                            </label>
                                                                            <input
                                                                                type="number"
                                                                                className="discount-value-input"
                                                                                value={disc.value || ''}
                                                                                onChange={(e) => setDiscountForItem(itemKey, prev => ({ ...prev, value: parseFloat(e.target.value) || 0 }))}
                                                                                placeholder="0"
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ color: '#64748b' }}>%</td>
                                                                    <td colSpan="2" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                                        {currencySymbol}{itemDiscAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td></td>
                                                                    <td>
                                                                        <button className="edit-item-delete" onClick={() => setDiscountForItem(itemKey, { active: false, type: 'percentage', value: 0 })}>
                                                                            <Trash2 size={14} />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            {/* Existing taxes for this item */}
                                                            {itemTaxes.map((t, ti) => {
                                                                const rate = parseFloat(t.Rate || 0);
                                                                const taxAmt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                                                                return (
                                                                    <tr key={`etax-${itemKey}-${ti}`} className="tax-subrow">
                                                                        <td></td><td colSpan="2"></td><td></td><td></td><td></td>
                                                                        <td style={{ color: '#64748b' }}>{t.Name}</td>
                                                                        <td><input readOnly={true} defaultValue={t.Rate} style={{ width: 48, border: '1px solid #e2e8f0', borderRadius: 4, padding: '2px 6px', backgroundColor: '#f8fafc', cursor: 'not-allowed', color: '#64748b' }} /></td>
                                                                        <td>%</td>
                                                                        <td>{currencySymbol} {taxAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                        <td><span style={{ color: '#ef4444', cursor: 'pointer' }}>🗑</span></td>
                                                                    </tr>
                                                                );
                                                            })}

                                                            {/* Added taxes for this item */}
                                                            {perItemAddedTaxes.map((at, ati) => {
                                                                const taxAmt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                                                                return (
                                                                    <tr key={`addtax-${itemKey}-${ati}`} className="tax-subrow">
                                                                        <td></td><td colSpan="2"></td><td></td><td></td><td></td>
                                                                        <td style={{ color: '#64748b' }}>{at.Name}</td>
                                                                        <td><input readOnly={true} value={at.Rate} style={{ width: 48, border: '1px solid #e2e8f0', borderRadius: 4, padding: '2px 6px', backgroundColor: '#f8fafc', cursor: 'not-allowed', color: '#64748b' }} /></td>
                                                                        <td>%</td>
                                                                        <td>{currencySymbol} {taxAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                        <td><button className="edit-item-delete" onClick={() => handleDeleteAddedTax(itemKey, ati)}><Trash2 size={14} /></button></td>
                                                                    </tr>
                                                                );
                                                            })}

                                                            {/* Per-item tax search dropdown (inline) */}
                                                            {isTaxSearchOpen && (
                                                                <tr className="tax-subrow">
                                                                    <td></td>
                                                                    <td colSpan="9">
                                                                        <div className="tax-search-container" style={{ padding: '4px 0' }}>
                                                                            <input
                                                                                type="text"
                                                                                className="tax-search-input"
                                                                                placeholder="Type a tax name"
                                                                                value={taxSearchText}
                                                                                onChange={(e) => {
                                                                                    setTaxSearchText(e.target.value);
                                                                                    fetchTaxSuggestions(e.target.value);
                                                                                }}
                                                                                autoFocus
                                                                            />
                                                                            {taxSuggestions.length > 0 && (
                                                                                <div className="tax-suggestions-dropdown">
                                                                                    {taxSuggestions.map((tax) => (
                                                                                        <div key={tax.Id} className="tax-suggestion-item" onClick={() => handleSelectTax(tax, itemKey)}>
                                                                                            <div className="tax-suggestion-name">{tax.Name}</div>
                                                                                            <div className="tax-suggestion-rate">{tax.Rate}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            {/* Per-item action buttons */}
                                                            <tr className="tax-subrow">
                                                                <td></td>
                                                                <td colSpan="9" style={{ textAlign: 'right', paddingRight: 16 }}>
                                                                    <button className="edit-add-btn" onClick={() => {
                                                                        if (disc.active) {
                                                                            Swal.fire({ title: 'Already Added', text: 'Discount has already been added. Please remove the existing discount first.', icon: 'warning', confirmButtonText: 'OK', confirmButtonColor: '#f59e0b' });
                                                                        } else {
                                                                            setDiscountForItem(itemKey, { active: true, type: 'percentage', value: 0 });
                                                                        }
                                                                    }}>+ Add Discount</button>
                                                                    <button className="edit-add-btn" style={{ marginLeft: 16 }} onClick={() => {
                                                                        setItemTaxSearchOpen(prev => ({ ...prev, [itemKey]: !prev[itemKey] }));
                                                                        setTaxSearchText('');
                                                                        setTaxSuggestions([]);
                                                                    }}>+ Add Tax</button>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    );
                                                }) : (
                                                    <tr><td colSpan="10" style={{ textAlign: 'center', color: '#94a3b8', padding: 20 }}>No items</td></tr>
                                                )}
                                            </tbody>
                                        </table>

                                        {/* Add Item Row */}
                                        <div className="edit-add-row">
                                            <button className="edit-add-btn" onClick={() => setItemSearchOpen(prev => !prev)}>+ Add an Item</button>
                                        </div>

                                        {/* Item Search Dropdown */}
                                        {itemSearchOpen && (
                                            <div className="tax-search-container">
                                                <input
                                                    type="text"
                                                    className="tax-search-input"
                                                    placeholder="Type an item name"
                                                    value={itemSearchText}
                                                    onChange={(e) => {
                                                        setItemSearchText(e.target.value);
                                                        fetchItemSuggestions(e.target.value);
                                                    }}
                                                    autoFocus
                                                />
                                                {(itemSuggestions.length > 0 || itemSearchText.length > 0) && (
                                                    <div className="tax-suggestions-dropdown">
                                                        {itemSuggestions.map((prod) => (
                                                            <div key={prod.Id} className="tax-suggestion-item item-suggestion-item" onClick={() => handleSelectItem(prod)}>
                                                                <div className="item-suggestion-left">
                                                                    <div className="item-suggestion-img">📦</div>
                                                                    <div>
                                                                        <div className="tax-suggestion-name">{prod.Name} &nbsp; <span style={{ color: '#64748b', fontWeight: 400 }}>☰ {prod.SalePrice || prod.Price || 0}</span></div>
                                                                        <div className="tax-suggestion-rate">{prod.Description || prod.Remarks || ''}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className="product-dropdown-footer">
                                                            <button className="edit-add-btn" style={{ width: '100%', border: 'none', background: 'none', color: '#1e293b', fontWeight: 700, fontSize: '14px', padding: '12px', cursor: 'pointer' }} onClick={() => { setIsProductAddOpen(true); }}>+Add New</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Totals */}
                                        <div className="edit-totals" style={{ marginTop: 0 }}>
                                            <div className="totals-row">
                                                <span>SUB TOTAL</span>
                                                <span>{currencySymbol} &nbsp; {subTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                            </div>
                                            {Object.entries(allTaxSummary).map(([name, amount], i) => (
                                                <div className="totals-row" key={`tax-${i}`}>
                                                    <span>{name.toUpperCase().replace(/_/g, ' ')}</span>
                                                    <span>{currencySymbol} &nbsp; {amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                                </div>
                                            ))}
                                            {addedCharges.map((ch, ci) => (
                                                <div className="totals-row" key={`charge-${ci}`}>
                                                    <span>{ch.type.toUpperCase().replace(/_/g, ' ')}</span>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        {currencySymbol} &nbsp; {parseFloat(ch.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                        <button className="charge-delete-btn" onClick={() => setAddedCharges(prev => prev.filter((_, i) => i !== ci))}>■</button>
                                                    </span>
                                                </div>
                                            ))}
                                            <div className="totals-row grand-total">
                                                <span>GRAND TOTAL</span>
                                                <span>{currencySymbol} &nbsp; {grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                            </div>
                                            <div style={{ textAlign: 'right', marginTop: 4 }}>
                                                <button className="edit-add-btn" style={{ fontSize: 12 }} onClick={() => setChargeModal({ open: true, type: '', amount: '' })}>+Add Charges</button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Terms & Condition */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label">Terms &amp; Condition</div>
                                        <div className="quill-editor-wrap">
                                            <SafeQuill
                                                theme="snow"
                                                value={editForm.termsCondition || ''}
                                                onChange={handleTermsChange}
                                                modules={quillModules}
                                                placeholder="Enter terms & conditions..."
                                            />
                                        </div>
                                    </div>

                                    {/* Notes */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label">Notes</div>
                                        <div className="quill-editor-wrap">
                                            <SafeQuill
                                                theme="snow"
                                                value={editForm.notes || ''}
                                                onChange={handleNotesChange}
                                                modules={quillModules}
                                                placeholder="Enter notes..."
                                            />
                                        </div>
                                    </div>

                                    {/* Footer (collapsible) */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label footer-toggle" onClick={() => setFooterOpen(prev => !prev)}>
                                            <span>Footer</span>
                                            {footerOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                        </div>
                                        {footerOpen && (
                                            <>
                                                <div className="edit-rich-label" style={{ fontSize: 12, marginTop: 8 }}>Footer</div>
                                                <div className="quill-editor-wrap">
                                                    <SafeQuill
                                                        theme="snow"
                                                        value={editForm.footer || ''}
                                                        onChange={handleFooterChange}
                                                        modules={quillModules}
                                                        placeholder="Enter footer content..."
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="edit-action-bar">
                                        <button className="edit-cancel-btn" onClick={() => setEditView(null)}>Cancel</button>
                                        <button className="edit-save-btn" onClick={handleSave} disabled={saveLoading}>
                                            {saveLoading ? 'Saving...' : 'Save'}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // ─── Main Render ──────────────────────────────────────────────────────────
    return (
        <>
            {/* Edit View Overlay */}
            {editView && renderEditPanel()}

            {/* Bill To Edit Modal */}
            {billToOpen && renderBillToModal()}

            {/* Ship To Edit Modal */}
            {shipToOpen && renderShipToModal()}

            {/* Item Edit Modals */}
            {renderItemEntityModal()}
            {renderItemDescriptionModal()}

            {/* Add Charges Modal */}
            {chargeModal.open && (
                <div className="billtto-modal-overlay" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>
                    <div className="billtto-modal charge-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="billtto-modal-header">
                            <span>Add Charges</span>
                            <button className="billtto-close-x" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>&times;</button>
                        </div>
                        <div className="billtto-modal-body" style={{ padding: '20px 24px' }}>
                            <label className="charge-label">Charge Type</label>
                            <select
                                className="charge-select"
                                value={chargeModal.type}
                                onChange={(e) => setChargeModal(prev => ({ ...prev, type: e.target.value, customName: '' }))}
                            >
                                <option value="">--Select Charge Type--</option>
                                <option value="Shipping Charge">Shipping Charge</option>
                                <option value="Adjustment">Adjustment</option>
                                <option value="Other">Other</option>
                            </select>
                            {chargeModal.type === 'Other' && (
                                <>
                                    <label className="charge-label" style={{ marginTop: 12 }}>Charge Name</label>
                                    <input
                                        type="text"
                                        className="charge-amount-input"
                                        placeholder="Enter Charge Name"
                                        value={chargeModal.customName || ''}
                                        onChange={(e) => setChargeModal(prev => ({ ...prev, customName: e.target.value }))}
                                    />
                                </>
                            )}
                            {chargeModal.type && (
                                <>
                                    <label className="charge-label" style={{ marginTop: 12 }}>Amount</label>
                                    <input
                                        type="number"
                                        className="charge-amount-input"
                                        placeholder="Enter Amount"
                                        value={chargeModal.amount}
                                        onChange={(e) => setChargeModal(prev => ({ ...prev, amount: e.target.value }))}
                                    />
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="charge-close-btn" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>close</button>
                            <button className="charge-apply-btn" onClick={() => {
                                if (!chargeModal.type || !chargeModal.amount) return;
                                const name = chargeModal.type === 'Other' ? (chargeModal.customName || 'Other') : chargeModal.type;
                                setAddedCharges(prev => [...prev, { type: name, amount: parseFloat(chargeModal.amount) || 0 }]);
                                setChargeModal({ open: false, type: '', amount: '' });
                            }}>Apply</button>
                        </div>
                    </div>
                </div>
            )}

            {isProductAddOpen && (
                <AddProductForm
                    onClose={() => setIsProductAddOpen(false)}
                    onSuccess={(prod) => {
                        handleSelectItem(prod);
                        setIsProductAddOpen(false);
                    }}
                    source="Invoice"
                />
            )}
        </>
    );
});

export default InvoiceFilterationAction;
